export default {
  computed: {
    allAutos() {
      return this.$store.state.AutoStore.all_autos || []
    }
  }
}